import axios from "axios";

/**
 * This is the API call that lazily loads media for a user.
 * ToDo: Do I need the pageParam?
 */
export const postPixel = async (
  userId,
  eventId,
  fbp,
  fbc
) => {
  const encodedUserId = userId.replace("#", "%23");
  let endpoint = `https://${process.env.REACT_APP_DOMAIN}/api/pixel?u=${encodedUserId}&eid=${eventId}&fbp=${fbp}`;
  if (fbc) {
    endpoint += `&fbc=${fbc}`;
  }
  console.log(endpoint);
   const resp = await axios.get(endpoint);
};
